module.exports = __webpack_public_path__ + "static/media/magnifying-glass.52eac682.svg";